<template>
  <section
    class="d-flex flex-wrap justify-center align-center justify-items-center"
    id="bg-overlay"
  >
    <div id="login-modal" class="white--text">
      <div class="text-center mb-6">
        <v-icon v-if="!$route.meta.logo" color="secondary" size="96">mdi-shield-key-outline</v-icon>
        <img
          v-else
          width="200"
          contain
          class="mx-auto mb-4"
          :src="logo" />
        <h1 class="my-2 mt-6 pa-0 text-uppercase text-center">Beléptetőrendszer</h1>
        <small text-center>{{ $route.meta.subtitle }}</small>
      </div>
      <div class="pa-4 px-sm-12">
        <form @submit.prevent="login">
          <v-text-field
            label="Email"
            type="email"
            filled
            dense
            v-model="form.email"
            dark
            :error-messages="errors.email"
            autofocus
          />
          <v-text-field
            label="Jelszó"
            filled
            v-model="form.password"
            :error-messages="errors.password"
            dark
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />

          <div class="d-flex flex-column justify-center align-center mt-4">
            <v-btn
              type="submit"
              color="primary"
              class="rounded-xl"
              x-large
              block
              depressed
              :loading="loading"
              :disabled="loading"
            >
              <v-icon class="mr-2" small>mdi-login-variant</v-icon>
              Bejelentkezés
            </v-btn>
          </div>
          <!-- <v-alert v-if="errors.login && errors.login.length" filled dismissible type="error" class="rounded-xl mt-4">
            <template v-for="error in errors.login">
              {{ error }}
            </template>
          </v-alert> -->
        </form>
      </div>
      <div class="text-center" style="position: relative">
        <small class="text-caption" :title="`Build #${buildNumber}\n${buildDate}`">
          {{ version }}
        </small>
      </div>
    </div>
  </section>
</template>

<script>
import { version } from '@/../package.json';

export default {
  data: function () {
    return {
      loadingTimer: null,
      version,
      form: {
        email: '',
        password: '',
      },
      message: {
        text: null,
        type: null,
      },
      loading: false,
      showPassword: false,
      errors: [],
    };
  },

  async mounted() {
    this.$store.commit('removeToken');
    this.$store.commit('removeUser');
  },

  methods: {
    async login() {
      this.loading = true;
      clearTimeout(this.loadingTimer);
      this.loadingTimer = setTimeout(() => {
        this.loading = false;
      }, 5000);
      this.errors = {};
      try {
        const response = await this.$http.post('auth/login', this.form);
        if (Object.keys(response.errors).length) {
          throw response.errors;
        }
        this.$store.commit('setUser', response.user);
        this.$router.push(this.$route.params.redirect || '/');
      } catch (err) {
        setTimeout(() => {
          this.errors = err;
          if (this.errors.login?.length) {
            this.$dialog.notify.error(err.login[0], { position: 'top-right' });
          }
        }, 500);
      } finally {
        setTimeout(() => (this.loading = false), 1000);
      }
    },
  },
  computed: {
    buildDate() {
      return new Date(process.env.VUE_APP_BUILD_DATETIME).toLocaleString();
    },
    buildNumber() {
      return parseInt(process.env.VUE_APP_BUILD_NUMBER);
    },
    shibLoginUrl() {
      return `${process.env.VUE_APP_API_URL}auth/shib/redirect?target=${process.env.VUE_APP_API_URL}auth/shib/login`;
    },
    logo() {
      console.log(this.$route.meta);
      return require('@/' + this.$route.meta.logo);
    },
    messageText() {
      return this.$route.params.message || this.message.text || false;
    },
    messageType() {
      return this.$route.params.messageType || this.message.type || 'warning';
    },
  },
};
</script>

<style lang="scss" scoped>
#bg-overlay {
  // background-color: var(--v-secondary-darken1);
  background-size: cover;
  background-attachment: fixed;
  position: absolute;
  min-height: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
  padding: 1rem;

  &::before {
    content: '';
    position: fixed;
    inset: 0;
    z-index: -2;
    // background: url('https://www.applepshostess.hu/wp-content/uploads/2020/05/Pusk%C3%A1s-Ar%C3%A9na.jpg') no-repeat center center;
    background: url('../../assets/Puskás_Aréna_01.jpg') no-repeat center center;
    // background: url('../../assets/41596.jpg') no-repeat center center;
    background-size: cover;
  }

  &::after {
    content: '';
    position: fixed;
    inset: 0;
    // background: rgba(28, 36, 66, 0.5);
    // background: #222a;
    z-index: -1;
    backdrop-filter: blur(0px) saturate(0) brightness(0.1) contrast(0.8);
    // mix-blend-mode: multiply;
  }

  #login-modal {
    margin: auto;
    width: 100%;
    max-width: 480px;
    background-color: #212121;
    border: 1px solid #ffffff18;
    border-top: 1px solid #ffffff22;
    border-bottom: 1px solid #ffffff11;
    // box-shadow: 0 6px 12px -6px #0008;
    padding: 3rem 1rem;
    border-radius: 16px;
    // border: 1px solid #fff1;
    // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

    * {
      color: #fff;
    }

    #header {
      // border-bottom: 2px solid var(--v-primary-base) !important;

      #logo {
        font-size: 63px;
      }

      h1 {
        line-height: 1 !important;
        font-size: 45px !important;
        letter-spacing: -4px;
        font-weight: 600;

        & > span {
          font-size: 35px;
          letter-spacing: -3px;
          font-weight: 300;
        }
      }
    }

    #body {
      h2 {
        color: inherit;
        font-weight: 400;
      }
    }
  }
}
</style>
